export default "__VITE_ASSET__7nmNfZ6n__"